import React from 'react';
import { Button } from 'react-bootstrap';
import styles from './refreshData.module.scss';
import { useI18N } from '../../../hooks';

interface Props {
    iconOnly?: boolean;
    small?: boolean;
    large?: boolean;
    className?: string;
    label?: string;
    onClick?: () => void;
    disabled?: boolean;
    loading?: boolean;
    error?: object | null | string;
}
export default function RefreshData({ iconOnly, small, large, className, onClick, label, disabled, loading, error }: Props) {
    const i18n = useI18N();
    const size = (small) ? 'sm' : (large) ? 'lg' : undefined;
    const isError = (error === null || error === undefined || error == 'No Errors Detected') ? false : true;
    const btnLabel = (loading) ? i18n.translateThis('Fetching...', i18n.localize.refreshData.fetching) : (!isError) ? (label) ? label : i18n.translateThis('Refresh Data', i18n.localize.refreshData.refreshData) : i18n.translateThis('Refresh Error', i18n.localize.refreshData.refreshError);
    const isDisabled = (disabled) ? true : (loading) ? true : false;

    return (
        <>
            {
                (iconOnly) ?
                    <i onClick={onClick} className={`fas cursor fa-sync text-info pr-3 ${styles.iconOnly} ${className}`} style={{ opacity: (isDisabled) ? .50 : 1 }}></i> :
                    <Button
                        size={(size === 'sm') ? 'sm' : (size === 'lg') ? 'lg' : undefined}
                        variant={(isError) ? 'danger' : 'info'}
                        className={className}
                        onClick={onClick}
                        disabled={isDisabled}
                    >
                        <>
                            <span className={'pr-2'}>{<i className="fas fa-sync text-white"></i>}</span>
                            <span className={'pr-1'}>{btnLabel}</span>
                        </>
                    </Button>


            }
        </>
    )
}